<template>
	<Teleport to="body">
		<div
			ref="modal-body"
			class="fixed top-0 left-0 z-50 w-full h-screen backdrop-brightness-75"
			v-bind="$attrs"
		>
			<div
				class="flex items-start justify-center w-full h-full overflow-y-auto"
				@click="close"
			>
				<div
					class="w-full max-w-lg mt-16 mb-4 bg-white border rounded-md"
					@click.stop
				>
					<section class="flex items-center p-4 border-b min-h-16">
						<h2 class="text-lg font-semibold">
							<slot name="header" />
						</h2>
						<AppButton
							variant="ghost"
							icon="close"
							class="ml-auto"
							aria-label="Sluiten"
							@click="close"
						/>
					</section>
					<section class="min-h-16">
						<slot name="default" :modal-body />
					</section>
					<section class="block px-6 py-4 border-t min-h-16 empty:hidden">
						<slot name="footer" />
					</section>
				</div>
			</div>
		</div>
	</Teleport>
</template>

<script setup lang="ts">
import { onKeyStroke } from "@vueuse/core";
import { useTemplateRef } from "vue";

const emit = defineEmits<{ hideModal: [] }>();
defineOptions({
	inheritAttrs: false,
});

const modalBody = useTemplateRef("modal-body");
defineExpose({ modalBody });

function close() {
	emit("hideModal");
}

onKeyStroke("Escape", close);
</script>
